import { BaseApiService } from './base';
import { buildApiUrl } from '../../utils/apiUrl';

export class SearchService extends BaseApiService {
  async searchDocuments(query: string): Promise<any[]> {
    try {
      // Utiliser l'API IA réelle
      // BEST PRACTICE: Utiliser buildApiUrl() pour construire l'URL de manière sûre
      const response = await fetch(buildApiUrl('/search/search/ai_search/'), {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({
          query: query,
          page: 1,
          page_size: 20
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('🔍 Résultats de recherche IA:', data);
      console.log('🔍 Premier résultat:', data.results?.[0]);
      console.log('🔍 Score du premier résultat:', data.results?.[0]?.score, typeof data.results?.[0]?.score);
      console.log('🔍 Tous les champs du premier résultat:', Object.keys(data.results?.[0] || {}));
      console.log('🔍 Semantic score:', data.results?.[0]?.semantic_score);
      
      // Retourner les résultats au format attendu par DocumentsPage
      const results = data.results || [];
      
      // Mapper les résultats pour inclure le score au bon endroit
      return results.map((result: any) => ({
        ...result,
        semantic_score: result.semantic_score || 0,
        score: result.semantic_score || 0  // Pour compatibilité
      }));
      
    } catch (error) {
      console.error('Erreur lors de la recherche IA:', error);
      throw new Error('Impossible d\'effectuer la recherche. Vérifiez votre connexion.');
    }
  }


  async getSearchSuggestions(query: string): Promise<string[]> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const suggestions = [
      'rapport financier',
      'budget 2024',
      'analyse marché',
      'contrat client',
      'planning projet',
      'présentation commerciale',
      'documentation technique',
      'procédure qualité'
    ];
    
    return suggestions.filter(suggestion => 
      suggestion.toLowerCase().includes(query.toLowerCase())
    ).slice(0, 5);
  }

  async summarizeSearchResults(results: any[]): Promise<string> {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    if (results.length === 0) {
      return 'Aucun document trouvé pour cette recherche.';
    }
    
    const types = Array.from(new Set(results.map(r => r.type)));
    const totalPages = results.reduce((sum, r) => sum + (r.total_pages || 1), 0);
    
    return `Recherche terminée : ${results.length} document(s) trouvé(s) (${types.join(', ')}), ${totalPages} page(s) au total.`;
  }

  async getSearchStats(): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 100));
    
    return {
      totalSearches: Math.floor(Math.random() * 1000) + 500,
      avgResponseTime: Math.floor(Math.random() * 200) + 100,
      popularQueries: [
        'rapport financier',
        'budget 2024',
        'analyse marché',
        'contrat client',
        'planning projet'
      ]
    };
  }

  async getSearchHistory(): Promise<string[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    
    const history = localStorage.getItem('search_history');
    return history ? JSON.parse(history) : [];
  }
}

export const searchService = new SearchService();